<template>
  <div>
    <el-table :data="bannedUsers" style="width: 60%;">
      <el-table-column prop="shop_name" label="店家">
      </el-table-column>
      <el-table-column prop="name" label="會員">
        <template slot-scope="{row}">
          {{ row.name }}
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="會員電話">
        <template slot-scope="{row}">
          {{ twnPhoneFormat(row.phone) }}
        </template>
      </el-table-column>
      <el-table-column prop="banned_since" label="封鎖時間">
        <template slot-scope="{row}">
          {{ row.banned_since | toDateString }}
        </template>
      </el-table-column>
      <el-table-column prop="order_id" label="封鎖訂單號" align="center">
      </el-table-column>

      <el-table-column prop="action" label="解除封鎖？" align="center">
        <template slot-scope="{row}">
          <el-button type="primary" icon="el-icon-unlock" circle size="small"
            @click="liftBan(row)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { UserInfoMixin } from 'src/mixins/user-info.js';

import axios from 'axios';
import moment from 'moment';

export default {
  mixins: [ UserInfoMixin ],

  mounted() {
    this.fetchBannedUsers();
  },

  methods: {
    fetchBannedUsers() {
      let api = `${process.env.VUE_APP_APIHOST}/gaa/banned-users`;
      if (this.userType === 'eaa')
        api = `${process.env.VUE_APP_APIHOST}/eaa/banned-users`;
      axios.get(api)
      .then(response => {
        this.bannedUsers = response.data;
      })
      .catch(err => {
        this.$message.error(`無法取得封鎖列表，請稍後再試。`);
      });
    },

    liftBan(user) {
      console.warn(`Attempting to lift ban of user`, user);
      let c = confirm(`確定要解除封鎖此會員？ 會員：${user.name}`);
      axios.post(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${user.account_id}/lift-ban`,
        {
          "userId": user.id
        }
      )
      .then(response => {
        this.$message({
          type: 'success', message: `已經解除此會員的封鎖狀態：${user.name}`
        });
        // Reload the list.
        this.bannedUsers = [];
        this.fetchBannedUsers();
      })
      .catch(err => {
        console.error(`Cannot unblock this user somehow.`, err);
        this.$message.error(`無法解除封鎖，請稍後再試。`);
      });
    }
  },

  data() {
    return {
      bannedUsers: []
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    }
  },

  filters: {
    toDateString: ts => moment.unix(ts).format('LL')
  }
}
</script>